<template>
  <div>
    <!-- Search -->
    <div class="row mt-4">
      <div class="col-md-8">
        <input class="input form-control" @keypress.enter="find()" v-model="query.generic"
          placeholder="Pesquisar por placa ou renavam">
        <search-icon @click="find()" class="icon icon-within" />
      </div>

      <button class="col-md-1 ml-2 btn-sm btn-outline nowrap" :class="{ 'btn-outline-active': showFilter }"
        @click="showFilter = !showFilter">
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{ 'rotate-90': showFilter }" />
      </button>

      <button v-if="changeQuery" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>

    <!-- Badges -->
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters :query="query" @clearBadge="find()" @clearAllBadges="find()"
          :amount-changed="updateNumberOfBadges" :filters="badgesFilters" />
      </div>
    </div>

    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-3">
          <label for="vehicle-account">Conta</label>
          <Select2 :options="filterAccount" v-model="query.accountId" id="vehicle-account"
            title-load="Carregando contas..." />
        </div>

        <div class="col-md-3">
          <label for="vehicle-created-by">Criado por</label>
          <Select2 :options="filterCreatedBy" v-model="query.createdBy" id="vehicle-created-by"
            title-load="Carregando emails..." />
        </div>

        <div class="col-md-3">
          <label for="vehicle-updated-by">Atualizado por</label>
          <Select2 :options="filterUpdatedBy" v-model="query.updatedBy" id="vehicle-updated-by"
            title-load="Carregando emails..." />
        </div>

        <div class="col-md-3">
          <label for="vehicle-entity-status">Status</label>
          <select v-model="query.entityStatusId" id="vehicle-entity-status" class="browser-default custom-select">
            <option v-for="opt in (filterEntityStatusId ? filterEntityStatusId.table : [])" :key="opt.value" :value="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-4">
          <label for="type-period">Tipo do período</label>
          <select v-model="query.periodType" id="type-period" class="form-control">
            <option value="created_at">Data de criação</option>
            <option value="">Data de atualização</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" id="start-date" class="form-control">
        </div>

        <div class="col-md-4">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>
      </div>
    </template>
    <hr>

    <!-- Info -->
    <div class="row mt-4">
      <div class="col-md-12">
        <strong class="mr-3">
          {{ infoTotalModels }}
        </strong>

        <div class="float-right" style="display: inline-flex;align-items: center;">
          <small class="mr-2" style="white-space: nowrap">Ordenar por:</small>
          <select v-model="orderBy" class="browser-default custom-select">
            <option value="updated_at">Data de atualização</option>
            <option value="created_at">Data de criação</option>
            <option value="plate">Placa</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="row flex-fill d-flex justify-content-start">
      <div class="col-sm-12 mt-2">
        <table class="table table-borderless table-dfe">
          <thead>
            <tr>
              <th>ID</th>
              <th>Placa</th>
              <th>Renavam</th>
              <th>CPF/CNPJ</th>
              <th>Conta</th>
              <th>Criado por</th>
              <th>Atualizado por</th>
              <th>Status</th>
              <th>Criado em</th>
              <th>Atualizado em</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="vehicle in vehicles" :key="vehicle.id">
              <td>{{ vehicle.id }}</td>
              <td>{{ vehicle.plate || '-' }}</td>
              <td>{{ vehicle.renavam || '-' }}</td>
              <td>{{ $options.filters.cpfCnpj(vehicle.cpfCnpj) || '-' }}</td>
              <td>{{ getAccountName(vehicle) }}</td>
              <td>{{ vehicle.createdBy || '-' }}</td>
              <td>{{ vehicle.updatedBy || '-' }}</td>
              <td>{{ entityStatusName(vehicle) }}</td>
              <td>{{ vehicle.createdAt | datetime }}</td>
              <td>{{ vehicle.updatedAt | datetime }}</td>
              <td>
                <button @click="showVehicle(vehicle)" class="btn btn-outline">Detalhes</button>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination v-model="meta.currentPage" :total-count="meta.totalCount" :total-pages="meta.totalPages"
              @pagination="pagination" />
          </div>
        </div>
      </div>

      <ShowDataModal v-if="currentVehicle" v-model="showModal" :header="currentVehicle.plate" :data="currentVehicle"
        :deep="3" />
    </div>
  </div>
</template>

<script>
import BadgeFilters from '@/components/shares/BadgeFilters'
import GlobalLoading from '@/mixins/GlobalLoading'
import ModelMapper from '@/mixins/ModelMapper'
import Pagination from '@/components/shares/specialTag/Pagination'
import Select2 from '@/components/shares/Select2'
import ShowDataModal from '@/components/admin/ShowDataModal'
import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'
import { Filter } from '@/models/filter'

export default {
  components: { BadgeFilters, ChevronDownIcon, Pagination, SearchIcon, Select2, ShowDataModal },
  computed: {
    badgesFilters() {
      return [
        this.filterAccount,
        this.filterCreatedBy,
        this.filterUpdatedBy,
        this.filterEntityStatusId,
        this.filterPeriodType,
        this.filterStartDate,
        this.filterEndDate
      ]
    },
    vehicles() {
      return this.getModels || []
    }
  },
  created() {
    this.defaultModelSetting.updateQueryURL = true
    this.order.push('updated_at', 'desc')
    this.$set(this.query, 'periodType', '')
    this.$set(this.query, 'entityStatusId', '')

    const today = new Date().toISOString().split('T')[0]
    this.$set(this.query, 'startDate', today)
    this.$set(this.query, 'endDate', today)

    this.filterAccount = this.buildFilterAccount(this.allAccounts.data)
    this.filterCreatedBy = this.buildEmailFilter(this.allUsers.data, 'createdBy', 'Criado por')
    this.filterUpdatedBy = this.buildEmailFilter(this.allUsers.data, 'updatedBy', 'Atualizado por')
    this.loadEntityStatusFilter()

    this.asyncTemplateSelect({
      byURL: true,
      pagination: true
    })
  },
  data: () => ({
    currentVehicle: null,
    entityStatusNames: {},
    filterAccount: null,
    filterCreatedBy: null,
    filterUpdatedBy: null,
    filterEntityStatusId: null,
    filterPeriodType: new Filter({
      key: 'periodType',
      label: 'Tipo de período',
      type: 'select',
      table: [
        { label: 'Data de criação', value: 'created_at' },
        { label: 'Data de atualização', value: '' }
      ]
    }),
    filterStartDate: new Filter({
      key: 'startDate',
      label: 'Data inicial',
      type: 'date'
    }),
    filterEndDate: new Filter({
      key: 'endDate',
      label: 'Data final',
      type: 'date'
    }),
    modelPathPrefix: 'admin/maestro',
    nameModel: 'Vehicle',
    orderBy: 'updated_at',
    showModal: false,
    showFilter: false
  }),
  inject: ['allAccounts', 'allUsers', 'buildFilterAccount', 'getAccountName'],
  methods: {
    buildEmailFilter(users, key, label) {
      return new Filter({
        key,
        label,
        table: users.map(u => [u.email, u.email])
      })
    },
    loadEntityStatusFilter() {
      this.axios.v3.get('admin/entity_statuses', { params: { per_page: 1000 } })
        .then(response => {
          const statuses = (response.data || []).filter(es => es.friendly_name)

          this.entityStatusNames = statuses.reduce((map, es) => {
            map[es.id] = es.friendly_name
            return map
          }, {})

          this.filterEntityStatusId = new Filter({
            key: 'entityStatusId',
            label: 'Status',
            type: 'select',
            table: [['Todos', ''], ...statuses.map(es => [es.friendly_name, es.id])]
          })
        })
        .catch(e => this.$notify.addError(e))
    },
    entityStatusName(vehicle) {
      return this.entityStatusNames[vehicle.entityStatusId] || '-'
    },
    find() {
      this.asyncTemplateSelect()
    },
    showVehicle(vehicle) {
      this.currentVehicle = vehicle
      this.showModal = true
    }
  },
  mixins: [ModelMapper, GlobalLoading],
  name: 'MaestroVehiclesIndex',
  superMethods: {
    buildParams: ModelMapper.methods.buildParams
  },
  watch: {
    allAccounts: {
      deep: true,
      handler(value) {
        this.filterAccount = this.buildFilterAccount(value.data)
      }
    },
    allUsers: {
      deep: true,
      handler(value) {
        this.filterCreatedBy = this.buildEmailFilter(value.data, 'createdBy', 'Criado por')
        this.filterUpdatedBy = this.buildEmailFilter(value.data, 'updatedBy', 'Atualizado por')
      }
    },
    orderBy(newValue, oldValue) {
      if (newValue === oldValue) return

      this.order = []
      this.addOrderBy(newValue, 'desc')
      this.find()
    }
  }
}
</script>

<style scoped>
</style>
